import React, { useEffect } from 'react';
// import classnames from 'classnames';
import Abnormal from '@home/components/Abnormal';
import MilestoneBudgetCostTable, { IMilestoneBudgetCostTableInstance } from './MilestoneBudgetCostTable';
import useRequest from '@gp/hooks/useRequest';
import { fetchMilestoneApprovedBudgetsAndCosts } from '@gp/services/finance';

import type { IBaseProps } from '@home/types/common';
import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

interface IMilestoneApprovedBudgetCostProps extends IBaseProps {
  tableComp: React.RefObject<IMilestoneBudgetCostTableInstance>;
  projectId?: string;
  currentMilestone?: IMilestone | null;
  isExpandHistory?: boolean;
  setIsNoData?: React.Dispatch<React.SetStateAction<boolean>>;
}

const MilestoneApprovedBudgetCost: React.FC<IMilestoneApprovedBudgetCostProps> = (props) => {
  const { style, tableComp, projectId, currentMilestone, isExpandHistory, setIsNoData } = props;

  const { loading, data: res } = useRequest(fetchMilestoneApprovedBudgetsAndCosts, {
    defaultParams: [{ project_id: projectId || '' }],
  });

  const { list } = res?.data || {};
  const isListEmpty = !Array.isArray(list) || !list.length;

  useEffect(() => {
    setIsNoData?.(isListEmpty);
  }, [isListEmpty]);

  return (
    <Abnormal
      style={{ ...style, height: 340 }}
      loadingMsg="Loading..."
      nodataMsg={''}
      isLoading={loading}
      isNoData={false}
      isError={false}
      component={
        <MilestoneBudgetCostTable
          ref={tableComp}
          isListEmpty={isListEmpty}
          showBudgetChangeHistory={isExpandHistory}
          currentMilestone={currentMilestone}
          records={list}
        />
      }
    />
  );
};

export default MilestoneApprovedBudgetCost;
